/*
 * Filename: d:\projects\AutoFiFront\src\Theme\LinkStyled.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Tuesday, February 14th 2023, 2:19:02 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import { getThemeColor } from "Utils/ThemeColor";
import styled from "styled-components";

const LinkStyled = styled.a.attrs((props: any) => ({
    bgColor: props.bgColor,
}))`
color: ${(props: any) => getThemeColor(props.bgColor)};
&:hover{
    color: ${(props: any) => getThemeColor(props.bgColor)};
}
`;

export default LinkStyled;
